import React, { useEffect, useRef, useState } from "react";
import { Button, Col, Container, Row } from "react-bootstrap";

import Spinner from "../../assets/img/loading.gif";
import { useHistory } from "react-router";

// import Webcam from "react-webcam";
import Camera, { FACING_MODES, IMAGE_TYPES } from "react-html5-camera-photo";
import "react-html5-camera-photo/build/css/index.css";

const appUrl = `${process.env.REACT_APP_API_URL}`;

function PageCaptureImage(props) {
  const history = useHistory();
  const [dataUri, setDataUri] = useState("");
  const [isEKYC, setIsEKYC] = useState(false);

  const [isLoading, setIsLoading] = useState(false);

  const { ekycResult, _handleToast, dataAccount, ocrData } = props;

  useEffect(() => {
    if (!dataAccount) {
      history.push("/open-account/check-info");
      return;
    }
  }, []);

  function handleTakePhotoAnimationDone(dataUri) {
    // Do stuff with the photo...
    // const date = new Date()
  }

  function handleCameraError(error) {
    if (error?.name === "NotFoundError") {
      let _params = Object.assign({}, ocrData);
      _params.anheKyC = "";

      ekycResult(_params);
    }
  }

  // function handleCameraStart(stream) {
  // }

  // function handleCameraStop() {
  // }

  function dataURItoBlob(dataURI) {
    // convert base64/URLEncoded data component to raw binary data held in a string
    var byteString;
    if (dataURI.split(",")[0].indexOf("base64") >= 0)
      byteString = atob(dataURI.split(",")[1]);
    else byteString = unescape(dataURI.split(",")[1]);

    // separate out the mime component
    var mimeString = dataURI.split(",")[0].split(":")[1].split(";")[0];

    // write the bytes of the string to a typed array
    var ia = new Uint8Array(byteString.length);
    for (var i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }

    return new Blob([ia], { type: mimeString });
  }

  function validateStep2() {
    let isCheck = true;

    if (!dataUri) {
      isCheck = false;
    }

    return isCheck;
  }

  function _handleUploadFile() {
    if (!validateStep2()) {
      _handleToast("Quý khách chưa chụp ảnh khuôn mặt", "warning");
      return;
    }
    setIsLoading(true);
    const formData = new FormData();
    formData.append("anheKyC", dataURItoBlob(dataUri));

    // upload file
    const request = fetch(appUrl + "/uploadFile", {
      method: "POST",
      body: formData,
    });
    request
      .then((response) => response.json())
      .then((json) => {
        if (json.iRs == 1) {
          // create request

          const { data } = json;
          handleRequestOcr(data);
        } else {
          setIsLoading(false);
          _handleToast(json.rs, "error");
        }
      })
      .catch((error) => {
        setIsLoading(false);
        _handleToast(
          "Có lỗi trong quá trình xử lý. Vui lòng thử lại!",
          "error"
        );
        throw error;
      });
  }

  function acceptOpenOcr() {
    let _params = Object.assign({}, ocrData);
    _params.anheKyC = "";

    ekycResult(_params);
  }

  function handleRequestOcr(params) {
    const param = {
      sid: dataAccount?.S_ID,
      anhCmtTruoc: ocrData?.anhMatTruoc,
      anhTime1: params?.anheKyC,
      anhTime2: params?.anheKyC,
      anhTime3: params?.anheKyC,
    };

    const request = fetch(appUrl + "/faceId", {
      method: "POST",
      headers: {
        "Content-Type": "application/json; charset=UTF-8",
      },
      body: JSON.stringify(param),
    });
    request
      .then((response) => response.json())
      .then((json) => {
        setIsLoading(false);

        if (json.iRs === 1) {
          // create request
          if (json?.data?.status !== 200) {
            _handleToast("Khuôn mặt không hợp lệ, Hãy thử lại!", "error");
            setIsEKYC(true);
          } else {
            let _params = Object.assign({}, ocrData);
            _params.anheKyC = params?.anheKyC;

            ekycResult(_params);
          }
        } else {
          _handleToast(json.data?.message || json.sRs, "error");
          // ocrResult(null);
        }
      })
      .catch((error) => {
        setIsLoading(false);
        _handleToast(
          "Có lỗi trong quá trình xử lý. Vui lòng thử lại!",
          "error"
        );
        // ocrResult(null);
        throw error;
      });
  }

  return (
    <>
      {isLoading && (
        <div className="loading">
          <img src={Spinner} alt="" />
        </div>
      )}

      <Container>
        <Row>
          <Col lg="10" className="offset-lg-1">
            <div className="content pt180">
              <h2>Xác thực khuôn mặt</h2>
              <form
                className="yt-online-form-step mt-0 mb-5"
                id="OnlineForm-step-2"
                method="post"
                encType="multipart/form-data"
                noValidate="novalidate"
              >
                <div className="yt-alert-message alert alert-info" role="alert">
                  <span className="text-danger">*</span> Quay từ từ khuôn mặt
                  sang trái , sang phải sau đó nhìn thẳng màn hình.
                </div>
                <div className="yt-identify-card-wrap">
                  <Row className="mt-3">
                    <Col className="front-wrap text-center">
                      <div className="identify-card-item">
                        <div className="yt-upload-wrap" data-type="front">
                          {dataUri ? (
                            <img
                              src={dataUri}
                              alt=""
                              style={{ width: "640px", height: "480px" }}
                            />
                          ) : (
                            <Camera
                              // onTakePhoto={(dataUri) => {
                              //   handleTakePhoto(dataUri);
                              // }}
                              onTakePhotoAnimationDone={(dataUri) => {
                                handleTakePhotoAnimationDone(dataUri);
                              }}
                              onCameraError={(error) => {
                                handleCameraError(error);
                              }}
                              idealFacingMode={FACING_MODES.USER}
                              idealResolution={{ width: 640, height: 480 }}
                              imageType={IMAGE_TYPES.JPG}
                              imageCompression={0.97}
                              isMaxResolution={true}
                              isImageMirror={false}
                              isSilentMode={false}
                              isDisplayStartCameraError={true}
                              isFullscreen={false}
                              sizeFactor={1}
                              // onCameraStart={(stream) => {
                              //   handleCameraStart(stream);
                              // }}
                              // onCameraStop={() => {
                              //   handleCameraStop();
                              // }}
                            />
                          )}
                        </div>
                      </div>
                    </Col>
                  </Row>
                  <Row className="justify-content-center mt-4 mb-5">
                    <Button
                      onClick={() => history.goBack()}
                      className="prev-page"
                    >
                      Quay lại
                    </Button>
                    {!isEKYC && (
                      <Button
                        className="btn-next"
                        type="button"
                        onClick={_handleUploadFile}
                      >
                        TIẾP TỤC
                      </Button>
                    )}
                    {!isEKYC && (
                      <Button
                        className="btn-next"
                        type="button"
                        onClick={acceptOpenOcr}
                      >
                        Vẫn tiếp tục
                      </Button>
                    )}
                  </Row>
                </div>
              </form>
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default PageCaptureImage;
